import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import { TableCell } from '@mui/material'
import { DateTimeCompactField, TextField, ModelAutocompleteField } from '@front/squirtle'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = () => {
  const operator = hooks.useLocalFieldValue('operator')
  const [{ name: operator_name }] = hooks.useCustomerInfo(operator?.user_id || operator)

  const autocompleteMutatorService = useCallback(q => {
    const tokens = _.compact(_.split(_.trim(q || ''), ' '))
    if (_.isEmpty(tokens)) return undefined
    const clauses = tokens.map(tok => ({
      or: [
        { client_id: { startsWith: tok } },
        { contract: { client_id: { startsWith: tok } } }
      ]
    }))
    return tokens.length === 1 ? clauses[0] : { and: clauses }
  }, [])

  return <>
    <TableCell size={'small'}>
      <DateTimeCompactField
        name={'createdAt'}
        inputFormat={'DD/MM/YYYY HH:mm'}
        disabled
        renderInputProps={{
          inputProps: { style: { textAlign: 'center' } }
        }}
        disableOpenPicker
      />
    </TableCell>
    <TableCell size={'small'}> <TextCell value={operator_name} /></TableCell>
    <TableCell size={'small'} sx={{ width: 1 / 3 }}>
      <ModelAutocompleteField
        name={'service'}
        model_name='companyservice'
        config={{
          populate: ['contract'],
          mutator: elem => ({ label: `${_.get(elem, 'contract.client_id')} - ${_.get(elem, 'client_id')}`, ...elem })
        }}
        autocompleteMutator={autocompleteMutatorService}
        multiple={false}
        searchMode='search'
        allowNone={false}
        loadOnFocus
        loadOnMount
        renderInputProps={{
          inputProps: { style: { textAlign: 'center' } }
        }}
      />
    </TableCell>
    <TableCell size={'small'}>
      <TextField
        name={'reason'}
        inputProps={{ style: { textAlign: 'center' } }}
      />
    </TableCell>
  </>
}

export default React.memo(Row)
